import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import AnimatedSection from '../components/AnimatedSection';
import { Card, CardContent } from '../components/ui/card';
import ZohoFormEmbed from '../components/ZohoFormEmbed';

const TrialRequestPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="pt-24">
        {/* Hero Section */}
        <section className="py-8 lg:py-20 bg-gradient-to-b from-white to-gray-50">
          <div className="container mx-auto px-4">
            <AnimatedSection animation="fade-up">
              <div className="text-center max-w-4xl mx-auto">
                <h1 className="text-3xl lg:text-5xl font-bold mb-3 lg:mb-6" style={{ color: '#214140' }}>
                  Request a Trial
                </h1>
                <p className="text-base lg:text-xl text-gray-600 leading-relaxed">
                  Ready to see the full impact of Cordflex® in your ICU? Request a comprehensive trial
                  to experience how our solution can transform your line management workflow and improve patient outcomes.
                </p>
              </div>
            </AnimatedSection>
          </div>
        </section>

        {/* Form Section (Zoho Forms) */}
        <section className="py-8 lg:py-20" style={{ backgroundColor: '#DFEAF0' }}>
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto">
              <AnimatedSection animation="fade-up" disableOnMobile>
                <Card className="shadow-xl">
                  <CardContent className="p-2 sm:p-4">
                    <ZohoFormEmbed
                      form="TrialRequest"
                      perma="6KuxSf-arMzDZuC-fswNeeDPyWfup44Bij33fUVHRuM"
                      height="1829px"
                      title="Trial Request"
                    />
                  </CardContent>
                </Card>
              </AnimatedSection>
            </div>
          </div>
        </section>

        {/* Trial Benefits Section */}
        <section className="py-20 bg-white">
          <div className="container mx-auto px-4">
            <AnimatedSection animation="fade-up">
              <div className="text-center max-w-3xl mx-auto">
                <h2 className="text-3xl lg:text-4xl font-bold mb-6" style={{ color: '#214140' }}>
                  Prep for a Successful Trial
                </h2>
                <div className="grid md:grid-cols-3 gap-8 mt-12">
                  <div className="text-center">
                    <div className="w-16 h-16 rounded-full mx-auto mb-4 flex items-center justify-center" style={{ backgroundColor: '#8BBAB8' }}>
                      <span className="text-white font-bold text-xl">📦</span>
                    </div>
                    <h3 className="text-lg font-semibold mb-2">Cordflex Clips</h3>
                    <p className="text-gray-600">Cordflex clips for your trial period</p>
                  </div>
                  <div className="text-center">
                    <div className="w-16 h-16 rounded-full mx-auto mb-4 flex items-center justify-center" style={{ backgroundColor: '#8BBAB8' }}>
                      <span className="text-white font-bold text-xl">🎓</span>
                    </div>
                    <h3 className="text-lg font-semibold mb-2">Staff Training</h3>
                    <p className="text-gray-600">Comprehensive training for your nursing staff</p>
                  </div>
                  <div className="text-center">
                    <div className="w-16 h-16 rounded-full mx-auto mb-4 flex items-center justify-center" style={{ backgroundColor: '#8BBAB8' }}>
                      <span className="text-white font-bold text-xl">📊</span>
                    </div>
                    <h3 className="text-lg font-semibold mb-2">Data Analysis</h3>
                    <p className="text-gray-600">Detailed analysis of outcomes and ROI</p>
                  </div>
                </div>
              </div>
            </AnimatedSection>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default TrialRequestPage;